import React from 'react';
import PropTypes from 'prop-types';
import './locationSearch.scss';
import LocationAutocomplete from './autocomplete';

const {
  i18n: {
    __,
  },
} = wp;

const LocationSearch = (props) => {
  const {
    handleSearchExpanded,
    isSearchExpanded,
    suggestedRegions,
  } = props;

  return (
    <div className="location-search">
      <div className="location-search__form-container">
        <form className="location-search__form">
          <button
            type="button"
            className="location-search__close"
            onClick={handleSearchExpanded}
          >
            <span className="location-search__close-icon">
              <span className="screen-reader-text">
                {__('Close search', 'nbc')}
              </span>
            </span>
          </button>
          <LocationAutocomplete
            suggestedRegions={suggestedRegions}
            isSearchExpanded={isSearchExpanded}
          />
        </form>
      </div>
    </div>
  );
};

LocationSearch.propTypes = {
  handleSearchExpanded: PropTypes.func.isRequired,
  isSearchExpanded: PropTypes.bool.isRequired,
  suggestedRegions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
};

export default LocationSearch;
